import { baseApi } from './baseApi';
import { DSLConfig, ValidationResult } from '../types/dynamicRouting';

const BASE_API = '/assets'

export const dslApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // Validate configuration
    validateConfig: builder.mutation<ValidationResult,DSLConfig>({
      query: (config) => ({
        url: `${BASE_API}/validate`,
        method: 'POST',
        body: { config },
      }),
    }),

    // fetch existing rules
    getRules: builder.query<DSLConfig, string>({
      query: (assetId) => `${BASE_API}/config-rules?assetId=${assetId}`,
    }),

    // save config
    saveConfig: builder.mutation<any, { assetId: string; config: DSLConfig }>({
      query: ({ assetId, config }) => ({
        url: `${BASE_API}/save/config-rules/${assetId}`,
        method: "POST",
        body: { config },
      }),
    }),

    getDynamicRulesLogs: builder.query<any[], string>({
      query: (assetId) => `${BASE_API}/dynamic-rules/logs/${assetId}`,
    }),

  }),
});

export const {
  useValidateConfigMutation,
  useGetRulesQuery,   
  useSaveConfigMutation, 
  useGetDynamicRulesLogsQuery,
} = dslApi;
